// linkAgentDev — small shared helpers for the Link (V2) chat, extracted so BOTH
// the persistent LinkAgentProvider and the LinkAgentSurface view can reuse them
// without a circular import between the two modules.
//
// - DEV model-picker persistence (loadDevModelChoice / saveDevModelChoice): lets
//   the team A/B LLM providers/models while Nexilink is in testing. The last
//   choice is remembered in localStorage so it carries to the NEXT new chat
//   (between-chat switching); mid-chat switching goes through the backend
//   SetModel endpoint. Remove this block (+ the picker UI) when we settle on a
//   model. encode/decode keep provider+model in one "provider|id" token.
// - decodeArtifactContent: decode a base64 artifact payload, tolerating UTF-8
//   (the AI emits Swedish + emoji frequently).

export const DEV_MODEL_LS_KEY = 'nexilink.dev.onboardingModel';

export function loadDevModelChoice(): { provider: string; model: string } | null {
    try {
        const raw = localStorage.getItem(DEV_MODEL_LS_KEY);
        if (!raw) return null;
        const c = JSON.parse(raw);
        if (c && typeof c.provider === 'string' && typeof c.model === 'string') return c;
    } catch { /* ignore */ }
    return null;
}

export function saveDevModelChoice(provider: string, model: string) {
    try {
        localStorage.setItem(DEV_MODEL_LS_KEY, JSON.stringify({ provider, model }));
    } catch { /* ignore */ }
}

// Decode the base64 artifact payload — tolerate UTF-8 chars (the AI emits
// Swedish + emoji frequently).
export function decodeArtifactContent(b64: string): string {
    try {
        const binary = atob(b64);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
        return new TextDecoder('utf-8').decode(bytes);
    } catch {
        return '';
    }
}
